import React from 'react';
import { motion } from 'framer-motion';
import { X, Zap, BookOpen } from 'lucide-react';
import { ProgressBar } from '../ui/Progress';
interface PracticeHeaderMinimalProps {
  currentQuestion: number;
  totalQuestions: number;
  streak: number;
  onExit: () => void;
  levelLabel?: string;
  onToggleCheatSheet?: () => void;
  isCheatSheetOpen?: boolean;
}
export function PracticeHeaderMinimal({
  currentQuestion,
  totalQuestions,
  streak,
  onExit,
  levelLabel,
  onToggleCheatSheet,
  isCheatSheetOpen
}: PracticeHeaderMinimalProps) {
  const progress = currentQuestion / totalQuestions * 100;
  return <div className="bg-white border-b border-slate-100 px-4 py-3 sticky top-0 z-30 shadow-sm" data-id="element-1361">
      <div className="max-w-3xl mx-auto flex items-center gap-4" data-id="element-1362">
        <button onClick={onExit} className="p-2 -ml-2 text-slate-400 hover:text-slate-600 hover:bg-slate-50 rounded-full transition-colors" title="Stoppen" data-id="element-1363">
          <X className="w-6 h-6" data-id="element-1364" />
        </button>

        <div className="flex-1" data-id="element-1365">
          <div className="flex justify-between items-center mb-1.5" data-id="element-1366">
            <span className="text-sm font-bold text-slate-700" data-id="element-1367">
              Vraag {currentQuestion}{' '}
              <span className="text-slate-400 font-normal" data-id="element-1368">
                / {totalQuestions}
              </span>
            </span>
            <div className="flex items-center gap-2" data-id="element-1369">
              {levelLabel && <span className="text-xs font-bold text-indigo-600 bg-indigo-50 px-2 py-0.5 rounded hidden sm:inline-block" data-id="element-1370">
                  {levelLabel}
                </span>}
            </div>
          </div>
          <ProgressBar value={progress} height={6} color="bg-indigo-600" data-id="element-1371" />
        </div>

        <div className="flex items-center gap-2" data-id="element-1372">
          {onToggleCheatSheet && <button onClick={onToggleCheatSheet} className={`p-2 rounded-full transition-all ${isCheatSheetOpen ? 'bg-indigo-100 text-indigo-600' : 'text-slate-400 hover:text-indigo-600 hover:bg-indigo-50'}`} title="Spiekbriefje" data-id="element-1373">
              <BookOpen className="w-5 h-5" data-id="element-1374" />
            </button>}

          <div className="flex items-center gap-1.5 bg-orange-50 px-3 py-1.5 rounded-full border border-orange-100" data-id="element-1375">
            <Zap className="w-4 h-4 text-orange-500 fill-current" data-id="element-1376" />
            <span className="text-sm font-bold text-orange-700" data-id="element-1377">{streak}</span>
          </div>
        </div>
      </div>
    </div>;
}